export const apiKey = 'YNB3fJ3C8C8A5A4C2A-9UJHAEFZMUJOYGYQEa1c1ZJg1RAeF5C4C3D3E2C2B4D6A3A1=='
export const config = {
        key: "YNB3fJ3C8C8A5A4C2A-9UJHAEFZMUJOYGYQEa1c1ZJg1RAeF5C4C3D3E2C2B4D6A3A1==",
        placeholderText: 'Edit Your Content Here!',
        fontSizeSelection: true,
        fontSize: ["8", "10", "12", "14", "18", "30", "60", "96"],
        toolbarButtons: {
          moreText: {
            buttons: [
              "html",
              "bold",
              "italic",
              "underline",
              "strikeThrough",
              "subscript",
              "superscript",
              "fontFamily",
              "fontSize",
              "textColor",
              "backgroundColor",
              "inlineClass",
              "inlineStyle",
              "clearFormatting"
            ]
          },
          moreParagraph: {
            buttons: [
              "alignLeft",
              "alignCenter",
              "formatOLSimple",
              "alignRight",
              "alignJustify",
              "formatOL",
              "formatUL",
              "paragraphFormat",
              "paragraphStyle",
              "lineHeight",
              "outdent",
              "indent",
              "quote"
            ]
          },
          moreRich: {
            buttons: [
              "insertLink",
              "insertImage",
              "insertVideo",
              "insertTable",
              "emoticons",
              "fontAwesome",
              "specialCharacters",
              "embedly",
              "insertFile",
              "insertHR"
            ]
          },
          moreMisc: {
            buttons: [
              "undo",
              "redo",
              "fullscreen",
              "print",
              "getPDF",
              "spellChecker",
              "selectAll",
              "help"
            ],
            align: "right",
            buttonsVisible: 2
          }
      },
}